import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';
import { Risk } from '@/types/risks';
import { window } from '@/js/external-js/variableModules/utils/window.util';

export async function getAllRisks(companyID: string): Promise<Risk[]> {
  const res = await deiterateAPI.POST(`/deiterateInternalAPI/risks/get/all`, {
    mode: 'cors',
    body: JSON.stringify({ companyID: companyID })
  });

  return res.risks.map(risk => ({
    ...risk,
    id: risk.componentId || risk.riskID,
    riskID: risk.riskID,
    componentId: risk.componentId,
    description: risk.risk || risk.risk || risk.description || '',
    riskRating: risk.riskRating || 'Medium',
    category: risk.team || risk.businessUnit,
    lastReviewDate: risk.lastReviewDate ? (new Date(risk.lastReviewDate)) : risk.lastReview ? (new Date(risk.lastReview)) : 'No Date Set',
    nextReviewDate: risk.nextReviewDate ? (new Date(risk.nextReviewDate)) : risk.nextReview ? (new Date(risk.nextReview)) : 'No Date Set',
    treatmentRequired: risk.treatRequired || risk.treatmentRequired || 'No',
  })) as Risk[];
}

export async function getRisk(companyID: string, riskID: string): Promise<Risk> {
  console.log('[risksService]', 'getRisk', riskID);
  const res = await deiterateAPI.POST(`/deiterateInternalAPI/risks/get/${riskID}`, {
    mode: 'cors',
    body: JSON.stringify({ companyID: companyID })
  });
  const risk = res.entry;
  console.log('[risksService]', 'getRisk', res.entry);

  return {
    ...risk,
    id: risk.componentId || risk.riskID,
    riskID: risk.riskID,
    description: risk.risk || risk.risk || risk.description || '',
    riskRating: risk.riskRating || 'Medium',
    category: risk.team || risk.businessUnit,
    lastReviewDate: risk.lastReviewDate ? (new Date(risk.lastReviewDate)) : risk.lastReview ? (new Date(risk.lastReview)) : 'No Date Set',
    nextReviewDate: risk.nextReviewDate ? (new Date(risk.nextReviewDate)) : risk.nextReview ? (new Date(risk.nextReview)) : 'No Date Set',
    treatmentRequired: risk.treatRequired || risk.treatmentRequired || 'No',
    relatedControls: [...(risk.relatedControls || []), ...(Array.isArray(risk.selectedControls) ? risk.selectedControls : [])],
    menus: res.menu || {},
  } as Risk;
}

export async function putRisk(companyID: string, riskID: string, riskItem: Risk): Promise<Risk> {
  const res = await deiterateAPI.POST(`/deiterateInternalAPI/risks/edit/${riskID}`, {
    mode: 'cors',
    body: JSON.stringify({ companyID: companyID, ...riskItem })
  });

  console.log('[risksService]', 'putRisk', companyID, riskItem);
// remove nextReview in favour of nextReviewDate
  if (riskItem.nextReview && riskItem.nextReviewDate) {
    delete riskItem.nextReview;
  }
  if (riskItem.lastReview && riskItem.lastReviewDate) {
    delete riskItem.lastReview;
  }

  if (riskItem.treatmentRequired && riskItem.treatRequired) {
    delete riskItem.treatRequired;
  }

  return {
    ...res,
    id: riskItem.id,
    description: riskItem.risk || riskItem.description || '',
    riskRating: riskItem.riskRating || 'Medium',
    category: riskItem.category || '',
    lastReviewDate: new Date(riskItem.lastReviewDate),
    nextReviewDate: new Date(riskItem.nextReviewDate),
    treatmentRequired: riskItem.treatmentRequired || riskItem.treatRequired || 'No',
    status: riskItem.status,
  } as Risk;
}

export async function createRisk(companyID: string, riskID: string, riskItem: Risk): Promise<Risk> {
  const res = await deiterateAPI.POST(`/deiterateInternalAPI/risks/add/${riskID}`, {
    mode: 'cors',
    body: JSON.stringify({ companyID: companyID, ...riskItem })
  });

  console.log('[risksService]', 'createRisk', companyID, riskItem);

  return {
    ...res,
    id: riskItem.id,
    description: riskItem.risk || riskItem.description || '',
    riskRating: riskItem.riskRating || 'Medium',
    category: riskItem.category || '',
    nextReviewDate: new Date(riskItem.nextReviewDate),
    status: riskItem.status,
  } as Risk;
}

export async function deleteRisk(companyID: string, riskID: string): Promise<void> {
  // deiterateAPI.POST throws on non-2xx responses, so no need to check statusCode
  await deiterateAPI.POST(`/deiterateInternalAPI/risks/delete/${riskID}`, {
    mode: 'cors',
    body: JSON.stringify({ companyID: companyID })
  });
}

export async function getMenus() {
  console.log('[DEBUG] getMenus called for companyID:', window.companyID);
  const res = await deiterateAPI.POST(`/deiterateInternalAPI/risks/get/menu`, {
    mode: 'cors',
    body: JSON.stringify({ companyID: window.companyID })
  });
  console.log('[DEBUG] getMenus response:', res);
  console.log('[DEBUG] getMenus riskCategory:', res.menu?.riskCategory);

  return res.menu;
}
